import React from 'react';
import styles from './UIGamePlayerInfoToggleContentPieces.module.scss';
import { PlayerColor } from '@colonist/game-states';
import ExpandPiecesRed from '@static/images/expand_pieces_red.svg';
import ExpandPiecesBlue from '@static/images/expand_pieces_blue.svg';
import ExpandPiecesOrange from '@static/images/expand_pieces_orange.svg';
import ExpandPiecesGreen from '@static/images/expand_pieces_green.svg';
import ExpandPiecesBlack from '@static/images/expand_pieces_black.svg';
import ExpandPiecesBrown from '@static/images/expand_pieces_brown.svg';
import ExpandPiecesSilver from '@static/images/expand_pieces_silver.svg';
import ExpandPiecesYellow from '@static/images/expand_pieces_yellow.svg';
import ExpandPiecesWhite from '@static/images/expand_pieces_white.svg';
import ExpandPiecesPurple from '@static/images/expand_pieces_purple.svg';
import ExpandPiecesMysticBlue from '@static/images/expand_pieces_mysticblue.svg';
import ExpandPiecesPink from '@static/images/expand_pieces_pink.svg';
const EXPAND_PIECES_IMAGE_PATH = {
    [PlayerColor.Red]: ExpandPiecesRed,
    [PlayerColor.Blue]: ExpandPiecesBlue,
    [PlayerColor.Orange]: ExpandPiecesOrange,
    [PlayerColor.Green]: ExpandPiecesGreen,
    [PlayerColor.Black]: ExpandPiecesBlack,
    [PlayerColor.Bronze]: ExpandPiecesBrown,
    [PlayerColor.Silver]: ExpandPiecesSilver,
    [PlayerColor.Gold]: ExpandPiecesYellow,
    [PlayerColor.White]: ExpandPiecesWhite,
    [PlayerColor.Purple]: ExpandPiecesPurple,
    [PlayerColor.MysticBlue]: ExpandPiecesMysticBlue,
    [PlayerColor.Pink]: ExpandPiecesPink
};
export const UIGamePlayerInfoToggleContentPieces = ({ playerColor })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.pieces,
        src: EXPAND_PIECES_IMAGE_PATH[playerColor]
    }));
